export const tenantKeys = {
  all: ["available-tenants"] as const,
};
